import React from 'react';
import { Button, Flex, FlexItem, Paragraph, } from '@stepstone-genesis/components';
import { Dissatisfied, DissatisfiedFilled, Neutral, NeutralFilled, Satisfied, SatisfiedFilled, StronglyDissatisfied, StronglyDissatisfiedFilled, StronglySatisfied, StronglySatisfiedFilled, } from 'modules/hub/components/AMAChat/shared/icons';
import labels from 'modules/hub/components/AMAChat/constants/labels/ama';
const Csat = ({ lang, response, onClick }) => {
    const csatIcons = [
        {
            id: 1,
            icon: React.createElement(StronglyDissatisfied, null),
            iconFilled: React.createElement(StronglyDissatisfiedFilled, null),
            a11yLabel: labels[lang].csatPrompt.smileys.rate1,
        },
        {
            id: 2,
            icon: React.createElement(Dissatisfied, null),
            iconFilled: React.createElement(DissatisfiedFilled, null),
            a11yLabel: labels[lang].csatPrompt.smileys.rate2,
        },
        {
            id: 3,
            icon: React.createElement(Neutral, null),
            iconFilled: React.createElement(NeutralFilled, null),
            a11yLabel: labels[lang].csatPrompt.smileys.rate3,
        },
        {
            id: 4,
            icon: React.createElement(Satisfied, null),
            iconFilled: React.createElement(SatisfiedFilled, null),
            a11yLabel: labels[lang].csatPrompt.smileys.rate4,
        },
        {
            id: 5,
            icon: React.createElement(StronglySatisfied, null),
            iconFilled: React.createElement(StronglySatisfiedFilled, null),
            a11yLabel: labels[lang].csatPrompt.smileys.rate5,
        },
    ];
    return (React.createElement(Flex, { flxDirection: "column" },
        React.createElement(FlexItem, { flxGrow: 1 },
            React.createElement("div", null,
                React.createElement(Paragraph, { mb: 'spaceS', mt: 'spaceS' }, labels[lang].csatPrompt.smileys.feedbackHeadline),
                React.createElement(Flex, { flxDirection: "row", flxItems: "center" }, csatIcons.map(({ id, icon, iconFilled, a11yLabel }) => (React.createElement(FlexItem, { key: id, flxFlex: "auto", sx: { textAlign: 'center' } },
                    React.createElement(Button, { iconOnly: response === id ? iconFilled : icon, variant: "linkSecondary", a11yLabel: a11yLabel, disabled: !!response, onClick: () => onClick({ id }) })))))))));
};
export default Csat;
